import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { WithingsOrderPostDataObject } from 'models/service';

export const editWithingsOrderPost = async ({
  htmlContent,
  programId,
  programTopicId,
  publishAt,
  textContent,
  title,
  todoDueDate,
  withingsPostOrderId,
}: {
  htmlContent: string;
  programId: string;
  programTopicId: string;
  publishAt: Date;
  textContent: string;
  title?: string;
  todoDueDate?: Date;
  withingsPostOrderId: string;
}) => {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
  const data = {
    withings_order_post: {
      html_content: htmlContent,
      program_id: programId,
      program_topic_id: programTopicId,
      publish_at: publishAt,
      text_content: textContent,
      title,
      todo_due_date: todoDueDate,
    },
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

  return apiClient.put<WithingsOrderPostDataObject, ApiClientResponse<WithingsOrderPostDataObject>>(
    routes.withings.editOrderPost(withingsPostOrderId),
    data,
  );
};
